<template>
    <header class="bg-white py-0 shadow-custom sm:top-0 sm:left-0 w-full z-50 relative md:sticky">
      <div class="container-fluid !p-0">
        <div class="flex justify-between items-center px-0 xl:px-[0] flex-col-reverse md:flex-row gap-4 sm:gap-0 bg-white">
          <div class="user flex justify-start items-start lg:items-center flex-col md:flex-row gap-3 border-t border-border py-4 lg:px-[30px] px-[16px] bg-white -mt-1">
            <div v-if="opt_type == 'mdsid'" class="py-4 lg:py-0 sm:pe-[16px] lg:pe-[30px] flex items-center justify-center md:justify-end relative bg-white bg-white w-full md:w-6/12 lg:w-auto">
            <img src="@/assets/images/seiulogo.jpg" alt="SEIU 721 logo" width="120" height="120"/>
          </div>
          <div class="flex items-start gap-3">
            <span class="w-[50px] h-[50px] bg-primary flex rounded-md items-center justify-center shrink-0">
              <img src="@/assets/images/user.svg" alt="user" />
            </span>
           <div v-if="opt_type != 'general' && opt_type != 'mdsid'">
              <h1 class="card-title !mb-0">New Member Enrollment Form</h1>
              <p class="content !mb-0">Thank you for your interest in U.S. Legal. To enroll, please proceed with completing the application.</p>
            </div>
            <div v-if="opt_type == 'mdsid'">
              <h1 class="card-title !mb-0">New Member Enrollment Form</h1>
              <p class="content !mb-0">Thank you for your interest in U.S. Legal. To enroll, please proceed with completing the application. Para asistencia con su aplicación, favor de contactar al 855-518-5297.<br>
              <b style="color:#ba4224;">If you are employed by the County of Los Angeles or City of Los Angeles, please contact 855-518-5297 to complete your enrollment.</b></p>
            </div>
             <div v-if="opt_type == 'general'" class="max-h-[150px] overflow-y-auto sm:max-h-none sm:overflow-visible pr-2">
              <h1 class="card-title !mb-0">New Member Enrollment Form</h1>
              <p class="content !mb-0">This form is to enroll directly with us utilizing a credit card pay method.</p>
              <p class="content !mb-0">If your company/group currently sponsors our legal plans as a voluntary benefit, please check with your Human Resources/Benefits Department to confirm how to enroll.</p>
            </div>
          </div>
          
          </div>
          <a href="index.html" class="py-4 lg:py-0 sm:pe-[16px] lg:pe-[30px] flex items-center justify-center md:justify-end relative bg-white w-full md:w-6/12 lg:w-auto">
              <img src="@/assets/images/USL_bridge_stacked_positive.png" alt="U.S. Legal Services logo" class="logo-css" />
            </a>
        </div>
      </div>
    </header>
  </template>
  
  <script>
  import { useStore } from 'vuex'; // Import the `useStore` hook from Vuex
  import { computed } from 'vue';
  export default {
    name: "HeaderComponent",
    setup() {
      const store = useStore(); // Access the Vuex store
      const opt_type = computed(() => store.state.opt_type)
      return {
        opt_type
      };
    }
  };
  </script>
  
  <style scoped>
  /* Add component-specific styles here if needed */
  </style>
  